import React, { useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import axios from "axios";
import Constant from "../Utils/Constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditSubscriptionForm = ({ editPopup, setEditPopup }) => {
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [planname, setPlanname] = useState("");
  const [price, setPrice] = useState("");
  const [planevalidity, setPlanevalidity] = useState("");
  const [validityUnit, setValidityUnit] = useState("days");
  const [planevisibility, setPlanevisibility] = useState([]);
  const [yourDataArray] = useState([
    { id: 1, planname: "Super Admin" },
    { id: 2, planname: "Admin" },
    { id: 3, planname: "Affiliate" },
    { id: 4, planname: "User" },
  ]);
  const [checkboxStates, setCheckboxStates] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  useEffect(() => {
    setInitialValues();
  }, [editPopup]);

  const setInitialValues = () => {
    setPlanname(editPopup.planname);
    setPrice(editPopup.price);
    setPlanevalidity(editPopup.planevalidity || '');
    setValidityUnit(editPopup.validityUnit || 'days');
    setPlanevisibility(editPopup.planevisibility);

    const initialCheckboxStates = yourDataArray.map((item) =>
      editPopup.planevisibility.includes(item.planname)
    );
    setCheckboxStates(initialCheckboxStates);
    setSelectAllChecked(initialCheckboxStates.every(Boolean));
  };

  const toggleDropdownfilter = () => {
    setIsDropdownOpenfilter(!isDropdownOpenfilter);
  };

  const handleCheckboxChanged = (index) => {
    const newCheckboxStates = [...checkboxStates];
    newCheckboxStates[index] = !newCheckboxStates[index];
    setCheckboxStates(newCheckboxStates);

    const selectedAccess = yourDataArray
      .filter((_, i) => newCheckboxStates[i])
      .map((item) => item.planname);
    setPlanevisibility(selectedAccess);

    setSelectAllChecked(newCheckboxStates.every(Boolean));
  };

  const handleSelectAllChanged = () => {
    const newSelectAllChecked = !selectAllChecked;
    setSelectAllChecked(newSelectAllChecked);
    const newCheckboxStates = Array(yourDataArray.length).fill(newSelectAllChecked);
    setCheckboxStates(newCheckboxStates);

    const selectedAccess = newSelectAllChecked
      ? yourDataArray.map((item) => item.planname)
      : [];
    setPlanevisibility(selectedAccess);
  };

  const countCheckedUsers = () => {
    return checkboxStates.filter((isChecked) => isChecked).length;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    
    // Validation - convert values to strings for trim operations
    if (!String(planname).trim()) {
      toast.error("Plan name is required");
      return;
    }
    if (!String(price).trim()) {
      toast.error("Price is required");
      return;
    }
    if (!planevalidity) {
      toast.error("Plan validity is required");
      return;
    }
    if (planevisibility.length === 0) {
      toast.error("Please select at least one plan visibility");
      return;
    }

    try {
      const subscriptionData = {
        planname: String(planname).trim(),
        price: String(price).trim(),
        planevalidity: Number(planevalidity),
        validityUnit,
        planevisibility,
      };
      const response = await axios.put(
        `${Constant.BASE_URL}/subscription/update/${editPopup._id}`,
        subscriptionData
      );
      if (response.status === 200) {
        setPrice("");
        setPlanname("");
        setPlanevisibility([]);
        toast.success("Plan Updated successfully");
        setEditPopup(false);
      } else {
        toast.error("Failed to update plan. Please try again.");
        console.log("Update failed:", response.status);
      }
    } catch (error) {
      console.error("Error updating plan:", error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Error updating plan. Please try again.");
      }
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="popup-form">
        <div className="w-full flex items-center justify-center">
          <div className="bg-white p-4 rounded-md shadow-md py-3 px-1 lg:py-3 xl:py-3 2xl:p-4">
            <div className="lg:w-[250px] xl:w-[270px] 2xl:w-[380px] items-center justify-center">
              <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl">
                Edit Plan
              </div>
              <hr className="mt-1" />
              <form onSubmit={handleUpdate}>
                <div className="flex flex-col items-center justify-center">
                  <div className="lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                    <div className="flex items-center justify-end py-3">
                      <label htmlFor="planname" className="flex items-end px-3">
                        Plan Name :<span className="ml-1 text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="planname"
                        className="flex items-start mb-2 border-b border-gray-500 outline-none"
                        style={{ width: "163px", textAlign: "center" }}
                        placeholder="Text"
                        value={planname}
                        onChange={(e) => setPlanname(e.target.value)}
                        required
                      />
                    </div>
                    <div className="flex items-center justify-end py-3">
                      <label htmlFor="price" className="flex items-end px-3">
                        Price (rs.) :<span className="ml-1 text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="price"
                        name="price"
                        className="flex items-start mb-2 border-b border-gray-500 outline-none"
                        style={{ width: "163px", textAlign: "center" }}
                        placeholder="Amount"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        required
                      />
                    </div>
                    <div className="flex items-center justify-end py-3">
                      <label htmlFor="validity" className="flex items-end px-3">
                        Validity :<span className="ml-1 text-red-500">*</span>
                      </label>
                      <div className="flex items-center gap-2" style={{ width: '163px' }}>
                        <input
                          type="number"
                          id="validity"
                          className="flex items-start mb-2 border-b border-gray-500 outline-none"
                          style={{ width: '80px', textAlign: 'center' }}
                          placeholder="e.g. 30"
                          value={planevalidity}
                          onChange={(e) => setPlanevalidity(e.target.value)}
                          min="1"
                          required
                        />
                        <select
                          value={validityUnit}
                          onChange={(e) => setValidityUnit(e.target.value)}
                          className="mb-2 border-b border-gray-500 outline-none bg-white"
                          style={{ width: '75px', textAlign: 'center' }}
                        >
                          <option value="days">Days</option>
                          <option value="hours">Hours</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <div className="relative flex items-center justify-start py-3 cursor-pointer mb-8">
                        <label htmlFor="planevisibility" className="flex items-end px-3">
                          Plan Visibility : {countCheckedUsers()} selected / {yourDataArray.length}
                          <span className="text-red-500 ml-1">*</span>
                        </label>
                        <div className="flex pb-1 border-b border-gray-500 outline-none">
                          <input
                            type="text"
                            placeholder="Select category"
                            value={planevisibility.join(', ')}
                            readOnly
                            style={{ border: "none", outline: "none" }}
                          />
                          <MdArrowDropDown
                            onClick={toggleDropdownfilter}
                            className="text-xl"
                          />
                          {isDropdownOpenfilter && (
                            <div
                              style={{
                                boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
                                borderRadius: '0 0 5px 5px',
                                zIndex: '100',
                              }}
                              className="lg:text-[10px] xl:w-[163px] lg:w-fit xl:text-[15px] absolute top-12 left-25 bg-white border border-white border-opacity-60 bg-white"
                            >
                              <ul className='overflow-y-auto h-[130px] modelscroll'>
                                <li className="border-t px-2 py-1 cursor-pointer text-black flex justify-between items-center">
                                  <span className='text-[12px]'>All</span>
                                  <div className='flex justify-end items-center'>
                                    <label className="inline-flex items-center">
                                      <div className={`w-4 h-4 bg-white border border-black-300 shadow-lg rounded-sm flex items-center justify-center ml-2 ${selectAllChecked ? 'bg-red-500' : ''}`}>
                                        {selectAllChecked && (
                                          <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                        )}
                                      </div>
                                      <input
                                        className="hidden"
                                        type="checkbox"
                                        checked={selectAllChecked}
                                        onChange={handleSelectAllChanged}
                                      />
                                    </label>
                                  </div>
                                </li>
                                {yourDataArray.map((option, index) => (
                                  <div key={option.id} className="border-t px-2 py-1 cursor-pointer text-black flex justify-between items-center">
                                    <span className='text-[12px]'>{option.planname}</span>
                                    <div className='flex items-center'>
                                      <label className="inline-flex items-center">
                                        <div className={`w-4 h-4 bg-white border border-black-300 shadow-lg rounded-sm flex items-center justify-center ml-2 ${checkboxStates[index] ? 'bg-red-500' : ''}`}>
                                          {checkboxStates[index] && (
                                            <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                          )}
                                        </div>
                                        <input
                                          className="hidden"
                                          type="checkbox"
                                          checked={checkboxStates[index]}
                                          onChange={() => handleCheckboxChanged(index)}
                                        />
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="button-container flex justify-center p-1 space-x-12 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                      <button
                        type="button"
                        onClick={() => setEditPopup(false)}
                        className="flex-shrink-0 px-3 py-1 bg-white shadow-md rounded-sm"
                        style={{
                          boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="flex-shrink-0 px-3 py-1 rounded-sm"
                        style={{
                          background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSubscriptionForm;
